import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1bee6822"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "thin text-xs"
}
const _hoisted_2 = ["value", "readonly", "disabled", "autofocus", "autocomplete", "placeholder"]
const _hoisted_3 = {
  key: 0,
  class: "relative h-4"
}
const _hoisted_4 = {
  key: 0,
  class: "absolute text-xs"
}
const _hoisted_5 = {
  key: 0,
  class: "absolute text-xs text-red-500"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["flex w-full flex-col", `${_ctx.label && 'space-y-1'}`])
  }, [
    _createElementVNode("label", {
      class: _normalizeClass(["leading-none input-label mb-1 text-gray-900", _ctx.labelClass])
    }, [
      _createTextVNode(_toDisplayString(_ctx.label) + " ", 1),
      (_ctx.optional)
        ? (_openBlock(), _createElementBlock("i", _hoisted_1, "(Opcional)"))
        : _createCommentVNode("", true)
    ], 2),
    _createElementVNode("textarea", {
      class: _normalizeClass([`${_ctx.height} ${_ctx.customClass} ${_ctx.isIncorrect && 'border-red-500'} ${
        _ctx.disabled && 'cursor-not-allowed'
      }`, "custom-textarea outline-none w-full resize-none rounded-lg border border-gray-300 py-2 px-3 transition-all duration-200 focus:border-brand"]),
      value: _ctx.modelValue,
      readonly: _ctx.readOnly,
      disabled: _ctx.disabled || _ctx.readOnly,
      autofocus: _ctx.autofocus,
      autocomplete: _ctx.autocomplete,
      placeholder: _ctx.placeholder,
      spellcheck: "false",
      onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', $event.target.value)))
    }, null, 42, _hoisted_2),
    (!_ctx.hideIncorrectMessage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_Transition, { name: "fade" }, {
            default: _withCtx(() => [
              (!_ctx.isIncorrect)
                ? (_openBlock(), _createElementBlock("span", _hoisted_4, " "))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_Transition, { name: "fade" }, {
            default: _withCtx(() => [
              (_ctx.isIncorrect)
                ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.incorrectMessage), 1))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ], 2))
}